class VariablesHelper {
  readonly FM_PATH_PARAM_NAME: string = 'path';
  readonly FM_SEARCH_PARAM_NAME: string = 'search';
  readonly FM_INPUT_SELECTOR_LS_KEY: string = 'fmInputSelectorLSKey';
  readonly FM_CURRENT_FILE_NAME_LS_KEY: string = 'fmCurrentFileNameLSKey';
  readonly FM_CURRENT_FILE_PATH_LS_KEY: string = 'fmCurrentFilePathLSKey';
  readonly SUCCESS_STATUS_TEXT: string = 'success';
  readonly SEARCH_INPUT_MIN_LENGTH: number = 3;
  readonly OPEN_TUTCO_IMMEDIATE_ASSISTANCE_MODAL_EVENT: string = 'open-tutco-immediate-assistance-modal';
  readonly WEBSITE_SIDEBAR_CLOSED_EVENT: string = 'website-sidebar-closed';
  readonly REGISTERED_RECENTLY_LS_KEY: string = 'registeredRecentlyLSKey';
  readonly LOGGED_IN_RECENTLY_LS_KEY: string = 'loggedInRecentlyLSKey';
  readonly AUTH_REDIRECT_URL_LS_KEY: string = 'authRedirectUrlLSKey';
}

export default new VariablesHelper();
